"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Item = function Item(_ref) {
  var className = _ref.className,
      icon = _ref.icon,
      onClick = _ref.onClick,
      children = _ref.children,
      isActive = _ref.isActive,
      otherProps = _objectWithoutProperties(_ref, ["className", "icon", "onClick", "children", "isActive"]);

  return /*#__PURE__*/_react.default.createElement(Container, _extends({}, otherProps, {
    className: className,
    isActive: isActive,
    onClick: onClick
  }), /*#__PURE__*/_react.default.createElement(SvgIcon, null, icon), /*#__PURE__*/_react.default.createElement("span", null, children));
};

var SvgIcon = _styledComponents.default.div.withConfig({
  displayName: "SvgIcon"
})(["max-height:4rem;width:6rem;text-align:left;"]);

var Container = _styledComponents.default.div.withConfig({
  displayName: "Container"
})(["display:flex;align-items:center;text-decoration:none;color:#525252;font-size:1.4rem;height:5rem;padding-left:2.5rem;font-weight:", ";width:100%;padding-right:1rem;text-align:center;background-color:", ";border-right:", ";border-color:", ";cursor:pointer;& span{text-align:left;width:100%;}&:hover{background-color:#f7f7f7;}&.active{font-weight:500;background-color:#f7f7f7;}"], function (props) {
  return props.isActive ? '500' : '400';
}, function (_ref2) {
  var isActive = _ref2.isActive;
  return isActive ? '#f7f7f7' : 'none';
}, function (_ref3) {
  var isActive = _ref3.isActive;
  return isActive ? '0.1rem solid' : 'none';
}, function (_ref4) {
  var isActive = _ref4.isActive,
      theme = _ref4.theme;
  return isActive ? theme.brand.primary : 'none';
});

Item.defaultProps = {
  isActive: false,
  onClick: function onClick() {},
  otherProps: {}
};
Item.propTypes = {
  /** Beeing able to use it in Styled Components */
  className: _propTypes.string,

  /** Adds extra props to the element */
  otherProps: _propTypes.object,
  isActive: _propTypes.bool,
  icon: _propTypes.element,
  onClick: _propTypes.func,
  children: _propTypes.node.isRequired
};
var _default = Item;
exports.default = _default;